import { Injectable, OnDestroy } from '@angular/core';
import { LoadingOptions } from '@ionic/core';
import { LoadingController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { LoadingDispatcher } from 'src/app/core/state/loading/loading.dispatcher';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';
import { ISopoLoadingState, LoadingState } from 'src/app/core/state/loading/loading.state';
import { AppState } from 'src/app/core/state/app.state';
import { Store } from '@ngrx/store';
import { SchedulerService } from '../scheduler/scheduler.service';

@Injectable({
    providedIn: 'root',
})
export class SopoLoadingService implements OnDestroy {

    private loadingStateSubscription: Subscription;
    private loading: HTMLIonLoadingElement;

    constructor(
        private loadingCtrl: LoadingController,
        private loadingDispatcher: LoadingDispatcher,
        private store: Store<AppState>,
        private scheduler: SchedulerService,
    ) {
        this.init();
    }
    ngOnDestroy(): void {
        if (this.loadingStateSubscription) {
            this.loadingStateSubscription.unsubscribe();
        }
    }
    
    init () {
        this.loadingStateSubscription = this.loadingDispatcher.getLoadingState().pipe(
            tap(loadingState => {
                // // ENABLE THIS TO OBSERVE ACTIVE LOADINGS
                // const loadings = Object.keys(loadingState).filter(key => loadingState[key]);
                // console.log(loadings);
            }),
            map((sopoLoadingState: ISopoLoadingState) => {
                const loadingState = {...sopoLoadingState.presented};
                return !Object.keys(loadingState).every((loadingKey) => !loadingState[loadingKey]) && !sopoLoadingState.paused
            }),
            distinctUntilChanged()
        ).subscribe((loadingToBePresented) => {
            if (loadingToBePresented) {
                this.scheduler.addTask({task:
                    async () => {
                        await this.create();
                        await this.loading.present();
                    },
                    taskType: 'loading'
                });
            } else {
                this.scheduler.addTask({task:
                    async () => {
                        if (this.loading) {
                            await this.loading.dismiss();
                        }
                    },
                    taskType: 'loading'
                });
            }
        })
    }

    private async create() {
        const loaderOptions: LoadingOptions = {
            cssClass: `chip-loader`,
            spinner: null,
        };
        this.loading = await this.loadingCtrl.create(loaderOptions);
    }
    
    present (loadingKey: keyof LoadingState): void;
    present (loadingKey: (keyof LoadingState)[]): void;
    present (loadingKey: keyof LoadingState | (keyof LoadingState)[]) {
        if (typeof loadingKey === 'string') {
            this.loadingDispatcher.presentLoading(loadingKey);
        }
        else {
            loadingKey.forEach((key) => this.loadingDispatcher.presentLoading(key));
        }
    }
    
    dismiss (loadingKey: keyof LoadingState): void;
    dismiss (loadingKey: (keyof LoadingState)[]): void;
    dismiss (loadingKey: keyof LoadingState | (keyof LoadingState)[]) {
        if (typeof loadingKey === 'string') {
            this.loadingDispatcher.dismissLoading(loadingKey);
        }
        else {
            loadingKey.forEach((key) => this.loadingDispatcher.dismissLoading(key));
        }
    }

    dismissAll () {
        this.loadingDispatcher.dismissAllLoading();
    }

    pause () {
        this.loadingDispatcher.pauseLoading();
    }

    resume () {
        this.loadingDispatcher.resumeLoading();
    }
}
